import React, { useEffect, useState } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import FileUploadModal from '../../shared/file-upload/FileUploadModal';
import FileList from '../../shared/file-upload/FileList';

function EditDealer({ DealerData, sendDataToParent }) {
  const [fileList, setFileList] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent({
      ...DealerData,
      [name]: value
    });
  };

  useEffect(() => {
    if (DealerData && DealerData.DealerId) {
      fetchFiles(DealerData.DealerId);
    }
  }, [DealerData.DealerId]);

  const fetchFiles = async (dealerId) => {
    try {
      const response = await axios.post(getApiBaseUrl() + "/file/list", {
        entityId: dealerId,
        entityType: 'dealer'
      });
      if (response.status === 200) {
        const payload = response?.data?.data;
        const normalized = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.[0])
            ? payload[0]
            : [];
        setFileList(normalized);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUploadConfirm = async ({ category, files, title }) => {
    if (!DealerData.DealerId) return;
    const formData = new FormData();
    formData.append('entityId', DealerData.DealerId);
    formData.append('entityType', 'dealer');
    formData.append('fileCategory', category || 'General');
    formData.append('fileTitle', title || '');
    formData.append('UserId', getStorageValues('userId'));
    (files || []).forEach((file) => formData.append('files', file, file.name));
    try {
      await axios.post(getApiBaseUrl() + "/file/upload", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      await fetchFiles(DealerData.DealerId);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDownload = (file) => {
    if (!file || !file.FileLibraryId) return;
    const url = `${getApiBaseUrl()}/file/download/${file.FileLibraryId}`;
    window.open(url, '_blank');
  };

  const handleDelete = async (file) => {
    if (!file || !file.FileLibraryId) return;
    try {
      await axios.post(getApiBaseUrl() + "/file/delete", { fileLibraryId: file.FileLibraryId });
      await fetchFiles(DealerData.DealerId);
    } catch (error) {
      console.log(error);
    }
  };
  

  return (
    <>
      <div className="row">
        <div className="col-lg-8 col-sm-6 col-12 mb-3">
          <label className="form-label">Dealer Name <span style={{ color: "red" }}>*</span></label>
          <input
            type="hidden"
            name="DealerId"
            value={DealerData.DealerId ?? ""}
          />
          <input
            type="text"
            className="form-control"
            name="DealerName"
            value={DealerData.DealerName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Mobile No</label>
          <input
            type="text"
            className="form-control"
            name="MobileNumber"
            value={DealerData.MobileNumber ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-sm-6 col-12 mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            name="EmailId"
            value={DealerData.EmailId ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-sm-6 col-12 mb-3">
          <label className="form-label">Address 1</label>
          <textarea 
              className="form-control" 
              rows="1" 
              name="AddressLine1"
              value={DealerData.AddressLine1 ?? ""}
              onChange={handleChange}
            />
        </div>
        <div className="col-lg-6 col-sm-6 col-12 mb-3">
          <label className="form-label">Address 2</label>
          <textarea 
              className="form-control" 
              rows="1" 
              name="AddressLine2"
              value={DealerData.AddressLine2 ?? ""}
              onChange={handleChange}
            />
        </div>
        <div className="col-lg-6 col-sm-6 col-12 mb-3">
          <label className="form-label">Address 3</label>
          <textarea 
              className="form-control" 
              rows="1" 
              name="AddressLine3"
              value={DealerData.AddressLine3 ?? ""}
              onChange={handleChange}
            />
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <label className="form-label">City</label>
          <input
            type="text"
            className="form-control"
            name="City"
            value={DealerData.City ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <label className="form-label">State</label>
          <input
            type="text"
            className="form-control"
            name="State"
            value={DealerData.State ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <label className="form-label">Country</label>
          <input
            type="text"
            className="form-control"
            name="Country"
            value={DealerData.Country ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <label className="form-label">Pin No</label>
          <input
            type="text"
            className="form-control"
            name="PinNumber"
            value={DealerData.PinNumber ?? ""}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">Attachments</h6>
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setShowUploadModal(true)}>
          Upload Files
        </button>
      </div>
      <FileList files={fileList} onDownload={handleDownload} onRemove={handleDelete} showRemove={true} />

      <FileUploadModal
        show={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onConfirm={handleUploadConfirm}
      />
    </>
  )
}

export default EditDealer